import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { ROUTER_PATHS, newMarcaProductosSchema } from '@/shared';
import { useCreateMarcasProduct, useUpdateMarcaProduct } from '@/shared/actions/erp';
import {
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { MARCASPRODUCTO } from '@/shared/interfaces';


export interface SaveMarcaProductosInterface {
  titlePage: string;
  editMarcaProductos?: MARCASPRODUCTO;
}

type SaveFormData = {
  nombre: string;
  estado: boolean;
  
};

const SaveMarcaProducto: React.FC<SaveMarcaProductosInterface> = ({ titlePage, editMarcaProductos }) => {
  const returnUrlMarcaProducto = ROUTER_PATHS.inventario.marca_productos_nav

  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createMarcaProductoMutation = useCreateMarcasProduct({ navigate, returnUrl: returnUrlMarcaProducto });
  const updateMarcaProductoMutation = useUpdateMarcaProduct({ navigate, returnUrl: returnUrlMarcaProducto });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newMarcaProductosSchema),
    defaultValues: { estado: false },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editMarcaProductos?.id_marca) {
      return updateMarcaProductoMutation.mutate({
        id: editMarcaProductos.id_marca,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createMarcaProductoMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editMarcaProductos) {
      setShrink(true);
      reset({
        ...editMarcaProductos,
      } as any);
    }
  }, [editMarcaProductos]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlMarcaProducto);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField 
        name="nombre"
        label="Nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveMarcaProducto;
